import { ReactNode } from 'react';
import styles from './infoCircleTooltip.module.scss';
import { PlacesType, Tooltip } from 'react-tooltip';

function InfoCircleTooltip({
  text,
  id,
  variant = 'info',
  customPlace,
}: {
  text: ReactNode;
  id: string;
  variant?: 'info' | 'warning' | 'error';
  customPlace?: PlacesType;
}) {
  return (
    <div className={styles.container}>
      <i data-tooltip-id={id} className={`fas fa-info-circle fa-sm ${styles[`${variant}Icon`]}`} />
      <Tooltip id={id} place={customPlace || 'right'} className={styles.tooltip} variant={variant} clickable>
        <div className={styles.tooltipText}>{text}</div>
      </Tooltip>
    </div>
  );
}

export default InfoCircleTooltip;
